const getTable = document.getElementById('node-table');

export const getTableHeight = getTable?.offsetHeight;
